import birthStrToDate from './birthStrToDate'

export default function getAge(str, pattern) {
  const birthDate = birthStrToDate(str, pattern)
  return new Date().getFullYear() - birthDate.getFullYear()
}
